module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-mv-imgline-631aca8cc9da26a7899ad4d1fecb5c4a.png";